import Service, { service } from '@ember/service';
import { variation } from 'ember-launch-darkly';

export default class ZendeskService extends Service {
  @service('browser/window') window;
  @service tagManager;

  isInitializing = false;

  identify() {
    this.track({ event: 'Zendesk Identify' });
  }

  track(data) {
    if (!this.hasInitialized) {
      this.initialize();
    }
    this.tagManager.push(data);
  }

  initialize() {
    if (this.isInitializing || this.hasInitialized) {
      return;
    }
    this.isInitializing = true;
    this.track({ event: 'Zendesk Initialize' });
    this.isInitializing = false;
  }

  logout() {
    if (this.hasInitialized && variation('release-zendesk-messaging')) {
      try {
        this.window.zE('messenger', 'close');
        this.window.zE('messenger', 'hide');
        this.window.zE('messenger', 'logoutUser');
      } catch (error) {
        console.warn('Failed to logout Zendesk widget:', error);
      }
    }
  }

  hide() {
    if (this.hasInitialized && variation('release-zendesk-messaging')) {
      try {
        this.window.zE('messenger', 'close');
        this.window.zE('messenger', 'hide');
      } catch (error) {
        console.warn('Failed to hide Zendesk widget:', error);
      }
    }
  }

  show() {
    if (this.hasInitialized && variation('release-zendesk-messaging')) {
      try {
        this.window.zE('messenger', 'show');
      } catch (error) {
        console.warn('Failed to show Zendesk widget:', error);
      }
    }
  }

  get hasInitialized() {
    return !!this.window.zE;
  }
}
